import request from '../utils/request';
import qs from "qs";

export function login(data) {
    return request({
        url: '/admin/login',
        method: 'POST',
        data
    })
}

export function getMemu(id) {
    return request({
        url: '/admin/admin/' + id + '/menu',
        method: 'GET'
    })
}

export function setAdminMenu(id, data) {
    return request({
        url: '/admin/admin/' + id + '/menu',
        method: 'PUT',
        header: {'Content-Type': 'application/x-www-form-urlencoded'},
        data: qs.stringify({"ids": data})
    })
}

export function getMenuList() {
    return request({
        url: '/admin/menu-in-all',
        method: 'GET'
    })
}

export function getMyMenu() {
    return request({
        url: '/admin/getMenuByRole',
        method: 'GET'
    })
}